import { TagIcon } from "../../asset/image";
import { ITag } from "../../shared/db";
import { useSelectTheme } from "../../store";
import { Tag, TagClickHandler } from "../atoms";

export interface ParticipantTagsContainerProps {
  tags: ITag[];
  showTrailingTagIcon?: boolean;
  onClick?: () => void;
}

export const ParticipantTagsContainer = (props: ParticipantTagsContainerProps) => {
  const { tags, showTrailingTagIcon, onClick } = props;
  const tagElements = tags.map((tag) => <Tag key={tag.id} tag={tag} />);
  if (showTrailingTagIcon) {
    tagElements.push(<img key="tagIcon" src={TagIcon} width={16} alt="" aria-hidden />);
  }
  const containerStyle = {
    minWidth: "144px",
    maxWidth: "400px",
    height: "100%",
    padding: "0 12px",
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap" as const,
    gap: 4,
    overflow: "hidden",
  };
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        style={{
          ...containerStyle,
          border: "none",
          background: "transparent",
          cursor: "pointer",
          font: "inherit",
        }}
      >
        {tagElements}
      </button>
    );
  }
  return <div style={containerStyle}>{tagElements}</div>;
};
